// src/pages/CGVPage.jsx
import React from 'react';
import LegalLayout from '../components/LegalLayout';
import Seo from '../components/Seo';

const CGVPage = () => {
  const articles = [
    {
      title: '1. Préambule',
      content: `
        <p>Les présentes Conditions Générales de Vente (ci-après "CGV") régissent les relations contractuelles entre :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>La société J7Lab, J7LAB SAS, propriétaire de "Y A Quoi à Manger" (aussi appelé "YAQAM") immatriculée au Registre du Commerce et des Sociétés sous le numéro 943 616 680, dont le siège social est situé 10 Chemin du Lac, 43000 POLIGNAC, FRANCE, représentée par J7 GROUP (ci-après "Y A Quoi A Manger" ou "YAQAM" ou "nous")</li>
        </ul>
        <p class="mt-2">Et :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Toute personne physique ou morale souhaitant utiliser les services payants proposés par YAQAM (ci-après "l'Utilisateur" ou "vous")</li>
        </ul>
      `
    },
    {
      title: '2. Objet',
      content: `
        <p>Les présentes CGV ont pour objet de définir les modalités et conditions d'utilisation des services payants proposés par YAQAM, ainsi que de définir les droits et obligations des parties dans ce cadre.</p>
      `
    },
    {
      title: '3. Description des services',
      content: `
        <p>YAQAM propose un service d'abonnement Premium donnant accès à des fonctionnalités avancées de planification de repas et de gestion de courses assistées par YAQAM.</p>
        <p class="mt-2">L'abonnement Premium comprend :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Génération de plans de repas hebdomadaires personnalisés et illimités</li>
          <li>Création automatique de listes de courses optimisées</li>
          <li>Commande automatique au drive (via API ou redirection)</li>
          <li>Suggestions de recettes anti-gaspi</li>
          <li>Support client prioritaire</li>
        </ul>
      `
    },
    {
      title: '4. Prix et modalités de paiement',
      content: `
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">4.1 Prix</h3>
        <p>Le prix de l'abonnement Premium est de 9,99€ TTC par mois.</p>
        <p class="mt-2">YAQAM se réserve le droit de modifier ses tarifs à tout moment. En cas de modification tarifaire, l'Utilisateur sera informé par email au moins 30 jours avant l'entrée en vigueur du nouveau tarif. L'Utilisateur aura alors la possibilité de résilier son abonnement s'il n'accepte pas cette modification.</p>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">4.2 Modalités de paiement</h3>
        <p>Le paiement s'effectue par carte bancaire via notre prestataire de paiement sécurisé. L'abonnement est facturé mensuellement, à date anniversaire de la souscription.</p>
        <p class="mt-2">En souscrivant à l'abonnement Premium, l'Utilisateur autorise YAQAM à prélever automatiquement le montant de l'abonnement à chaque échéance mensuelle.</p>
      `
    },
    {
      title: '5. Durée et résiliation',
      content: `
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.1 Durée</h3>
        <p>L'abonnement Premium est conclu pour une durée indéterminée avec une période minimale d'engagement d'un mois.</p>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.2 Résiliation par l'Utilisateur</h3>
        <p>L'Utilisateur peut résilier son abonnement à tout moment depuis son espace personnel. La résiliation prendra effet à la fin de la période mensuelle en cours, sans remboursement prorata temporis.</p>
        
        <h3 class="text-lg font-medium mt-4 mb-2" style="color: #2C3E50">5.3 Résiliation par YAQAM</h3>
        <p>YAQAM se réserve le droit de résilier l'abonnement d'un Utilisateur en cas de :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Non-paiement</li>
          <li>Violation des CGV ou des CGU</li>
          <li>Utilisation frauduleuse du service</li>
        </ul>
      `
    },
    {
      title: '6. Droit de rétractation',
      content: `
        <p>Conformément aux dispositions légales en vigueur, l'Utilisateur dispose d'un délai de 14 jours à compter de la souscription pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.</p>
        <p class="mt-2">Pour exercer ce droit, l'Utilisateur doit notifier sa décision de rétractation par email à info@j7lab.com ou par courrier à l'adresse du siège social.</p>
        <p class="mt-2">En cas d'exercice du droit de rétractation, YAQAM remboursera l'Utilisateur de tous les paiements reçus dans un délai de 14 jours à compter de la date de notification de la rétractation.</p>
      `
    },
    {
      title: '7. Responsabilité',
      content: `
        <p>YAQAM s'engage à fournir ses services avec diligence et selon les règles de l'art, étant précisé qu'il pèse sur elle une obligation de moyens, à l'exclusion de toute obligation de résultat.</p>
        <p class="mt-2">YAQAM ne saurait être tenue responsable des éventuels dysfonctionnements des services de drive partenaires, ni de la qualité des produits commandés via ces services.</p>
        <p class="mt-2">Les informations nutritionnelles fournies le sont à titre indicatif et ne sauraient remplacer les conseils d'un professionnel de santé.</p>
      `
    },
    {
      title: '8. Modifications des CGV',
      content: `
        <p>YAQAM se réserve le droit de modifier les présentes CGV à tout moment. En cas de modification, les nouvelles CGV seront notifiées à l'Utilisateur lors de sa prochaine connexion au service.</p>
        <p class="mt-2">L'Utilisateur qui n'accepte pas les nouvelles CGV doit résilier son abonnement avant l'entrée en vigueur des modifications. À défaut, les nouvelles conditions seront réputées acceptées.</p>
      `
    },
    {
      title: '9. Loi applicable et juridiction compétente',
      content: `
        <p>Les présentes CGV sont soumises au droit français.</p>
        <p class="mt-2">En cas de litige relatif à l'interprétation ou à l'exécution des présentes, les parties s'efforceront de trouver une solution amiable.</p>
        <p class="mt-2">À défaut d'accord amiable, tout litige sera soumis aux tribunaux compétents du ressort de la Cour d'appel de [ville], sous réserve des dispositions légales impératives contraires.</p>
      `
    }
  ];

  return (
    <>
      <Seo
        title="Conditions Générales de Vente"
        description="Consultez les conditions générales de vente et de facturation de YAQAM."
        noindex
        breadcrumb
      />
      <LegalLayout title="Conditions Générales de Vente (CGV)">
      <div className="space-y-8">
        {articles.map((article, index) => (
          <div key={index} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0">
            <h2 className="text-xl font-semibold mb-4" style={{ color: '#2C3E50' }}>{article.title}</h2>
            <div 
              className="text-gray-700"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </div>
        ))}
      </div>
      </LegalLayout>
    </>
  );
};

export default CGVPage;
